import { createApp } from 'vue'
import { createPinia } from 'pinia'
import router from './router'
import App from './App.vue'
import './assets/styles/global.css'
import { useAuthStore } from './stores/auth.js'
import i18n from './i18n'

const app = createApp(App)
const pinia = createPinia()

// 전역 에러 핸들러 추가
app.config.errorHandler = (err, vm, info) => {
  console.error('전역 Vue 에러:', err)
  console.error('컴포넌트:', vm)
  console.error('에러 정보:', info)
}

// Unhandled promise rejection 핸들러
window.addEventListener('unhandledrejection', event => {
  console.error('처리되지 않은 Promise rejection:', event.reason)
  console.error('Promise:', event.promise)
})

// 일반 에러 핸들러
window.addEventListener('error', event => {
  console.error('전역 JavaScript 에러:', event.error)
  console.error('파일:', event.filename)
  console.error('라인:', event.lineno)
})

app.use(pinia)
app.use(router)
app.use(i18n)

// Auth store 초기화 (앱 시작 시 로그인 상태 복원)
const authStore = useAuthStore()
authStore.initializeAuth()

// 앱 마운트 후 재생목록 초기화 (중복 방지)
app.mount('#app')

// DOM 마운트 후에 재생목록 초기화
setTimeout(() => {
  authStore.initializePlaylist()
}, 100)